// useOllamaModels.js — Lista os modelos Ollama locais do user.
//
// Vai via Electron IPC (electron/ollama.cjs) que bypassa CORS chamando
// `GET http://127.0.0.1:11434/api/tags` no main process. Quando rodando
// fora do Electron (Pages/web), retorna offline=true silenciosamente.
//
// Refresh manual disponível via `refresh()`. Auto-fetcha no mount + quando
// `enabled` vira true. Não polla — modelos locais mudam só quando user
// faz `ollama pull`/`ollama rm` (operações raras + intencionais).

import { useCallback, useEffect, useState } from 'react';

const DEFAULT_BASE_URL = 'http://127.0.0.1:11434';

export function useOllamaModels({ baseUrl = DEFAULT_BASE_URL, enabled = true } = {}) {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(false);

  const fetchModels = useCallback(async () => {
    if (typeof window === 'undefined' || !window.apolo?.ollama?.listModels) {
      setOffline(true);
      setError('IPC indisponível (rodando fora do Electron)');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await window.apolo.ollama.listModels({ baseUrl });
      if (res.ok) {
        setModels(res.models || []);
        setOffline(false);
      } else {
        setModels([]);
        setOffline(!!res.offline);
        setError(res.error || 'Falha ao listar modelos');
      }
    } catch (e) {
      setModels([]);
      setOffline(true);
      setError(e?.message || 'Erro inesperado');
    } finally {
      setLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    if (!enabled) return;
    fetchModels();
  }, [enabled, fetchModels]);

  return { models, loading, error, offline, refresh: fetchModels };
}
